export { FurnishedIcon } from './FurnishedIcon'
